"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoDiv = void 0;
/* eslint-disable no-alert */
/* eslint-disable prettier/prettier */
/* eslint-disable no-debugger */
/* eslint-disable max-len */
var icons_1 = require("@ant-design/icons");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var formik_1 = require("formik");
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var constants_1 = require("../../../../constants");
var hooks_1 = require("../../../../hooks");
var useBoolean_1 = __importDefault(require("../../../../hooks/useBoolean"));
// eslint-disable-next-line import/no-cycle
var DetailTlumocnikaPage_1 = require("../../../../pages/DetailTlumocnikaPage");
var ConfigProvider_1 = require("../../../../providers/ConfigProvider");
var either_1 = require("../../../../utils/either");
var Button_1 = __importDefault(require("../../../Button/Button"));
var LinkButton_1 = __importDefault(require("../../../Button/LinkButton"));
var BulbIcon_1 = __importDefault(require("../../../Icon/BulbIcon"));
var Padder_1 = require("../../../Padder");
var Popup_1 = __importDefault(require("../../../Popup/Popup"));
var Field_1 = __importDefault(require("../../components/Field"));
var Label_1 = __importDefault(require("../../components/Label"));
var Form_1 = __importDefault(require("../../Form"));
var NumberField_1 = __importDefault(require("../NumberField"));
var TextAreaField_1 = __importDefault(require("../TextAreaField"));
var TextField_1 = __importDefault(require("../TextField"));
var AddressResult_1 = __importDefault(require("./components/AddressResult"));
var AddressResultList_1 = __importDefault(require("./components/AddressResultList"));
var SelectTypAdresy_1 = __importDefault(require("./components/SelectTypAdresy"));
var utils_1 = require("./utils");
var validation_1 = require("./validation");
var BorderDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var $hasError = _a.$hasError;
    return $hasError && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border: 2px solid #ba0d23;\n      border-radius: 4px;\n      height: 50px;\n      padding-top: 12px;\n      padding-left: 2px;\n    "], ["\n      border: 2px solid #ba0d23;\n      border-radius: 4px;\n      height: 50px;\n      padding-top: 12px;\n      padding-left: 2px;\n    "])));
});
exports.InfoDiv = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 13px 36px 10px 20px;\n  font-size: 15px;\n  line-height: 140%;\n  letter-spacing: 0.0125em;\n  margin-bottom: 25px;\n  background-color: #e5ebf0;\n  border-left: 4px solid #2362a2;\n  display: flex;\n  & > * {\n    color: #3b3b3b;\n  }\n"], ["\n  padding: 13px 36px 10px 20px;\n  font-size: 15px;\n  line-height: 140%;\n  letter-spacing: 0.0125em;\n  margin-bottom: 25px;\n  background-color: #e5ebf0;\n  border-left: 4px solid #2362a2;\n  display: flex;\n  & > * {\n    color: #3b3b3b;\n  }\n"])));
var PopupChildren = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  overflow: auto;\n  max-height: 90vh;\n  min-height: 480px;\n"], ["\n  overflow: auto;\n  max-height: 90vh;\n  min-height: 480px;\n"])));
var CenteredDiv = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-top: 2em;\n  display: flex;\n  justify-content: center;\n"], ["\n  margin-top: 2em;\n  display: flex;\n  justify-content: center;\n"])));
var FieldRow = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n\n  & > div:first-child {\n    grid-template-columns: auto;\n  }\n\n  & > div:last-child {\n    margin-left: 1em;\n    margin-top: 0;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n\n  & > div:first-child {\n    grid-template-columns: auto;\n  }\n\n  & > div:last-child {\n    margin-left: 1em;\n    margin-top: 0;\n  }\n"])));
var StyledFontAwesomeIcon = styled_components_1.default(react_fontawesome_1.FontAwesomeIcon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var StyledCloseButton = styled_components_1.default(icons_1.CloseCircleFilled)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  color: #005285;\n  margin-left: 10px;\n  display: flex;\n  align-self: baseline;\n  font-size: 16px;\n"], ["\n  color: #005285;\n  margin-left: 10px;\n  display: flex;\n  align-self: baseline;\n  font-size: 16px;\n"])));
var MarginLeft = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  margin-left: 5px;\n  display: flex;\n  align-self: stretch;\n"], ["\n  margin-left: 5px;\n  display: flex;\n  align-self: stretch;\n"])));
var ButtonsDiv = styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: flex;\n  column-gap: 10px;\n"], ["\n  display: flex;\n  column-gap: 10px;\n"])));
var DisabledButton = styled_components_1.default(LinkButton_1.default)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  opacity: 0.5;\n  pointer-events: none;\n\n  * {\n    cursor: not-allowed !important;\n  }\n\n  cursor: not-allowed !important;\n"], ["\n  opacity: 0.5;\n  pointer-events: none;\n\n  * {\n    cursor: not-allowed !important;\n  }\n\n  cursor: not-allowed !important;\n"])));
var AddressField = function (_a) {
    var _b, _c, _d, _e;
    var label = _a.label, name = _a.name, filterResult = _a.filterResult, header = _a.header, systemId = _a.systemId, readOnly = _a.readOnly, hideTypAdresy = _a.hideTypAdresy, zadaneTypyAdres = _a.zadaneTypyAdres, isZnalec = _a.isZnalec, disabled = _a.disabled, kopie = _a.kopie;
    var _f = formik_1.useField(name), field = _f[0], meta = _f[1], helpers = _f[2];
    var _g = react_1.useState([]), adresy = _g[0], setAdresy = _g[1];
    var isOpen = useBoolean_1.default(false);
    var iszrUrl = ConfigProvider_1.useConfig().iszrUrl;
    var postJSON = hooks_1.usePostJSON(iszrUrl + "/VyhledejAdresu");
    var token = hooks_1.useToken();
    var _h = react_1.useState(undefined), evidencni = _h[0], setEvidenci = _h[1];
    var _j = react_1.useState(undefined), initError = _j[0], setInitError = _j[1];
    var _k = react_1.useState(undefined), initValue = _k[0], setInitValue = _k[1];
    var uzivatel = 'Anonymous';
    if (((_b = token.getDataFromToken()) === null || _b === void 0 ? void 0 : _b.name) || ((_c = token.getDataFromToken()) === null || _c === void 0 ? void 0 : _c.surname)) {
        uzivatel = ((_d = token.getDataFromToken()) === null || _d === void 0 ? void 0 : _d.name) + " " + ((_e = token.getDataFromToken()) === null || _e === void 0 ? void 0 : _e.surname);
    }
    var handleSubmit = function (formResult, formikHelpers) { return __awaiter(void 0, void 0, void 0, function () {
        var obec, castObce, ulice, cisloPopisne, cisloOrientacni, cisloOrientacniZnak, psc, cisloEvidencni, adresaText, filteredFormResult, response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    formikHelpers.setStatus(undefined);
                    setAdresy([]);
                    obec = formResult.obec, castObce = formResult.castObce, ulice = formResult.ulice, cisloPopisne = formResult.cisloPopisne, cisloOrientacni = formResult.cisloOrientacni, cisloOrientacniZnak = formResult.cisloOrientacniZnak, psc = formResult.psc, cisloEvidencni = formResult.cisloEvidencni, adresaText = formResult.adresaText;
                    if (adresaText && adresaText.length > 1) {
                        // jen ulozit adresu, nevolat RUIAN
                        helpers.setValue(__assign(__assign({}, formResult), { typAdresy: formResult.typAdresy }));
                        isOpen.setFalse();
                        return [2 /*return*/];
                    }
                    filteredFormResult = ramda_1.pickBy(function (val) { return val; }, {
                        uzivatel: uzivatel,
                        obec: obec === null || obec === void 0 ? void 0 : obec.trim(),
                        castObce: castObce === null || castObce === void 0 ? void 0 : castObce.trim(),
                        ulice: ulice === null || ulice === void 0 ? void 0 : ulice.trim(),
                        cisloPopisne: cisloPopisne || cisloEvidencni,
                        cisloOrientacni: cisloOrientacni,
                        cisloOrientacniZnak: cisloOrientacniZnak === null || cisloOrientacniZnak === void 0 ? void 0 : cisloOrientacniZnak.trim(),
                        psc: psc,
                    });
                    filteredFormResult.SystemId = systemId;
                    return [4 /*yield*/, postJSON(filteredFormResult)];
                case 1:
                    response = _a.sent();
                    formikHelpers.setSubmitting(false);
                    if (either_1.isRight(response)) {
                        if (!response.value.length) {
                            formikHelpers.setStatus({
                                type: 'error',
                                message: 'Adresa nenalezena v RUIAN. Zkontrolujte, prosím, vložené údaje a případně proveďte opravu a nový pokus o ověření.',
                            });
                        }
                        else if (response.value.length === 1) {
                            setEvidenci(response.value[0].cisloEvidencni);
                            helpers.setValue(__assign(__assign({}, response.value[0]), { typAdresy: formResult.typAdresy }));
                            isOpen.setFalse();
                        }
                        else if (response.value.length <= 5) {
                            setAdresy(response.value.map(function (adresa) { return (__assign(__assign({}, adresa), { typAdresy: formResult.typAdresy })); }));
                        }
                        else if (response.value.length > 5) {
                            formikHelpers.setStatus({
                                type: 'error',
                                message: 'Na základě zadaných dotazů byl nalezen příliš velký počet výsledků. Zpřesněte, prosím, vyhledávanou adresu vyplněním více položek formuláře.',
                            });
                        }
                        return [2 /*return*/];
                    }
                    formikHelpers.setStatus({ type: 'error', message: response.value.message });
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    formikHelpers.setStatus({ type: 'error', message: e_1.message });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getEnumAdresyForSystemId = function (sid) {
        return sid === 'Tlumocnici' ? constants_1.TlumocniciTypAdresy : constants_1.ZnalciTypAdresy;
    };
    react_1.useEffect(function () {
        var _a;
        if (isOpen.value) {
            var enumObj = getEnumAdresyForSystemId(systemId);
            if (hideTypAdresy) {
                if (!((_a = field.value) === null || _a === void 0 ? void 0 : _a.typAdresy)) {
                    if (filterResult) {
                        var allowedTypes = Object.values(enumObj).filter(function (id) {
                            return filterResult({ id: id });
                        });
                        if (allowedTypes.length === 1) {
                            setInitValue({ typAdresy: allowedTypes[0] });
                        }
                    }
                    else {
                        var allowedTypes = Object.values(enumObj);
                        if (allowedTypes.length > 0) {
                            setInitValue({ typAdresy: allowedTypes[0] });
                        }
                    }
                }
                else {
                    setInitValue(field.value || {});
                }
            }
            else {
                setInitValue(field.value || {});
            }
        }
    }, [isOpen.value]);
    var handleSelect = function (adresa) {
        setEvidenci(adresa.cisloEvidencni);
        helpers.setValue(adresa);
        setAdresy([]);
        isOpen.setFalse();
    };
    var handleDeleteAdresy = function () {
        helpers.setValue(undefined);
    };
    var handleCopy = function (copyValues) {
        var valid = validation_1.addressFieldValidation(hideTypAdresy, zadaneTypyAdres, isZnalec)(copyValues);
        if (Object.keys(valid).length) {
            setInitValue(copyValues);
            setInitError(valid);
            isOpen.setTrue();
        }
        else
            helpers.setValue(copyValues);
    };
    return (react_1.default.createElement(Field_1.default, null,
        react_1.default.createElement(Label_1.default, { htmlFor: name }, label),
        react_1.default.createElement(BorderDiv, { "$hasError": !!meta.error && !field.value },
            react_1.default.createElement(ButtonsDiv, null,
                !field.value &&
                    (disabled ? (react_1.default.createElement(DisabledButton, { type: "button", className: "button" }, "P\u0159idat")) : (react_1.default.createElement(LinkButton_1.default, { type: "button", className: "button", onClick: isOpen.toggle }, "P\u0159idat"))),
                kopie &&
                    (disabled ? (react_1.default.createElement(DisabledButton, { type: "button", className: "copyButton" }, kopie.popis)) : (react_1.default.createElement(LinkButton_1.default, { type: "button", className: "copyButton", onClick: function () { return handleCopy(__assign(__assign({}, kopie.adresa), { typAdresy: kopie.default })); } }, kopie.popis)))),
            field.value && (react_1.default.createElement(AddressResult_1.default, null,
                utils_1.getAddressLabel(field.value),
                !readOnly && !disabled && (react_1.default.createElement(MarginLeft, null,
                    react_1.default.createElement(StyledFontAwesomeIcon, { icon: free_solid_svg_icons_1.faPen, color: "#005285", width: 15, title: "Editovat", onClick: isOpen.toggle }),
                    react_1.default.createElement(StyledCloseButton, { onClick: handleDeleteAdresy }))))),
            react_1.default.createElement(Popup_1.default, { open: isOpen.value, onClose: function () {
                    setInitError(undefined);
                    setInitValue(undefined);
                    isOpen.setFalse();
                } },
                react_1.default.createElement(PopupChildren, null,
                    adresy.length > 1 && react_1.default.createElement(AddressResultList_1.default, { addressResults: adresy, onSelect: handleSelect }),
                    react_1.default.createElement(Form_1.default, { initialValues: initValue || field.value || {}, initialErrors: initError || {}, validate: function (values) {
                            setInitValue(undefined);
                            setInitError(undefined);
                            return validation_1.addressFieldValidation(hideTypAdresy, zadaneTypyAdres, isZnalec)(values);
                        }, onSubmit: handleSubmit }, function (_a) {
                        var _b, _c;
                        var isSubmitting = _a.isSubmitting, values = _a.values;
                        return (react_1.default.createElement(Padder_1.Padder, null,
                            react_1.default.createElement(DetailTlumocnikaPage_1.StyledH2, null, header),
                            react_1.default.createElement(exports.InfoDiv, null,
                                react_1.default.createElement(BulbIcon_1.default, null),
                                react_1.default.createElement("div", null,
                                    "Pro ov\u011Bren\u00ED adresn\u00EDho m\u00EDsta je pot\u0159eba zadat v\u017Edy minim\u00E1ln\u011B pole ",
                                    react_1.default.createElement("b", null, "Obec"),
                                    " a ",
                                    react_1.default.createElement("b", null, "PS\u010C"),
                                    " a k n\u011Bmu doplnit kombinaci ",
                                    react_1.default.createElement("b", null, "Ulice"),
                                    " a ",
                                    react_1.default.createElement("b", null, "\u010C\u00EDslo orienta\u010Dn\u00ED"),
                                    ' ',
                                    "(p\u0159\u00EDpadn\u011B i ",
                                    react_1.default.createElement("b", null, "Znak o. \u010D."),
                                    " tj. p\u00EDsmeno dodatku \u010D\u00EDsla orienta\u010Dn\u00EDho, nap\u0159. \u201CA\u201D \u010Di \u201CB\u201D) nebo ",
                                    react_1.default.createElement("b", null, "\u010C\u00EDslo popisn\u00E9"),
                                    ".")),
                            !hideTypAdresy && react_1.default.createElement(SelectTypAdresy_1.default, { name: "typAdresy", label: "Typ adresy", filterResult: filterResult }),
                            values.typAdresy && values.typAdresy === constants_1.TlumocniciTypAdresy.adresaSidlaZahranicni && !isZnalec && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(TextAreaField_1.default, { name: "adresaText", label: "Adresa", toolTip: "Vypl\u0148te adresu pobytu v zahrani\u010D\u00ED", maxLength: 250 }),
                                react_1.default.createElement(CenteredDiv, null,
                                    react_1.default.createElement(Button_1.default, { type: "submit", primary: true, loading: isSubmitting, name: "Overit" }, "Ulo\u017Eit")))),
                            values.typAdresy && (values.typAdresy !== constants_1.TlumocniciTypAdresy.adresaSidlaZahranicni || isZnalec) && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(TextField_1.default, { label: "Ulice", name: "ulice", toolTip: "Vypl\u0148te n\u00E1zev ulice" }),
                                !evidencni && !((_b = field === null || field === void 0 ? void 0 : field.value) === null || _b === void 0 ? void 0 : _b.cisloEvidencni) && (react_1.default.createElement(NumberField_1.default, { label: "\u010C\u00EDslo popisn\u00E9 / eviden\u010Dn\u00ED", name: "cisloPopisne", size: "md", toolTip: "Vypl\u0148te \u010D\u00EDslo popisn\u00E9 / eviden\u010Dn\u00ED" })),
                                (((_c = field === null || field === void 0 ? void 0 : field.value) === null || _c === void 0 ? void 0 : _c.cisloEvidencni) || evidencni) && (react_1.default.createElement(NumberField_1.default, { label: "\u010C\u00EDslo popisn\u00E9 / eviden\u010Dn\u00ED", name: "cisloEvidencni", size: "md", toolTip: "Vypl\u0148te \u010D\u00EDslo popisn\u00E9 / eviden\u010Dn\u00ED" })),
                                react_1.default.createElement(Field_1.default, null,
                                    react_1.default.createElement(Label_1.default, { htmlFor: "cisloOrientacni" }, "\u010C\u00EDslo orienta\u010Dn\u00ED"),
                                    react_1.default.createElement(FieldRow, null,
                                        react_1.default.createElement(NumberField_1.default, { label: "", name: "cisloOrientacni", displayFlex: true, toolTip: "Vypl\u0148te \u010D\u00EDslo orienta\u010Dn\u00ED" }),
                                        react_1.default.createElement(TextField_1.default, { label: "Znak o.\u010D.", name: "cisloOrientacniZnak", toolTip: "Vypl\u0148te znak o.\u010D." }))),
                                react_1.default.createElement(TextField_1.default, { label: "\u010C\u00E1st obce", name: "castObce", toolTip: "Vypl\u0148te n\u00E1zev \u010D\u00E1sti obce" }),
                                react_1.default.createElement(TextField_1.default, { label: "Obec", name: "obec", toolTip: "Vypl\u0148te n\u00E1zev obce" }),
                                react_1.default.createElement(NumberField_1.default, { label: "PS\u010C", name: "psc", size: "md", toolTip: "Vypl\u0148te PS\u010C" }),
                                react_1.default.createElement(CenteredDiv, null,
                                    react_1.default.createElement(Button_1.default, { type: "submit", primary: true, loading: isSubmitting, name: "Overit" }, "Ov\u011B\u0159it v RUIAN"))))));
                    }))))));
};
AddressField.defaultProps = {
    filterResult: undefined,
    readOnly: false,
    hideTypAdresy: false,
    zadaneTypyAdres: undefined,
    isZnalec: false,
    disabled: undefined,
    kopie: undefined,
};
exports.default = AddressField;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
